import React from "react";
import { useTranslation } from "react-i18next";
import Button from "@mui/material/Button";
import styles from "./AppHeader.module.scss";
import UserMenu from "./components/UserMenu/UserMenu";
import { RegionIndicator } from "./components/RegionIndicator/RegionIndicator";
import { useUserSession } from "../../hooks/useUserSession";
import { SessionExpirationManager } from "../SessionExpirationManager/SessionExpirationManager";
import { useNavigation } from "../../hooks/useNavigation";
import { AuthUtils } from "../../utils/AuthUtils";
import { ROUTES } from "utils/navigationUtils";
import Stack from "@mui/material/Stack";

interface Props {
  hideSignInButton?: boolean;
}

const AppHeader: React.FC<Props> = ({ hideSignInButton }) => {
  const { username, email, isFederatedSsoAccount } = useUserSession();
  const { navigateTo } = useNavigation();

  const signIn = React.useCallback(async () => {
    await AuthUtils.signIn();
  }, []);

  const onSignUpClick = React.useCallback(() => {
    navigateTo(ROUTES.SIGN_UP);
  }, [navigateTo]);

  const { t } = useTranslation();

  return (
    <div className={styles.headerDiv}>
      {username && <SessionExpirationManager />}
      <header>
        <div className={styles.logo}>
          <img src={t("configuration.logoUrl.image")} alt={t("configuration.logoUrl.altText")} />
        </div>
        <Stack direction="row" spacing={2} alignItems="center" className={styles.loginService}>
          <RegionIndicator />
          {!username && (
            <span>
              {!hideSignInButton && (
                <span id="sign-in-button-span">
                  <Button id="sign-in-button" onClick={signIn} variant="contained">
                    {t("appHeader.signIn")}
                  </Button>
                  <span>{t("appHeader.or")}</span>
                </span>
              )}
              <Button variant="contained" color="primary" onClick={onSignUpClick}>
                {t("appHeader.signUp")}
              </Button>
            </span>
          )}
          {username && <UserMenu username={isFederatedSsoAccount ? email || username : username} />}
        </Stack>
      </header>
    </div>
  );
};

export default AppHeader;
